import { useEffect } from 'react';
import { useTemplateEditorDispatch, useTemplateEditorState } from '../context/UseTemplateEditorContext';
import { isEqual } from 'core/ui/utils/isEqual';
/**
 * Listens for any changes to the template, the compiled body or the compiled css.
 * If a changed is detected it marks the template as 'preview required'.
 */
export const useListenAndPreviewTemplate = () => {
  const {
    template,
    lastCompiledTemplateBody,
    compilationContext,
    lastCompiledCompilationContext,
  } = useTemplateEditorState();
  const dispatch = useTemplateEditorDispatch();

  useEffect(() => {
    if (
      isEqual(template.template, lastCompiledTemplateBody) &&
      isEqual(compilationContext, lastCompiledCompilationContext)
    ) {
      dispatch({
        type: 'SET_PREVIEW_REQUIRED',
        payload: { requiresPreview: false },
      });
    } else {
      dispatch({
        type: 'SET_PREVIEW_REQUIRED',
        payload: { requiresPreview: true },
      });
    }
  }, [compilationContext, dispatch, lastCompiledCompilationContext, lastCompiledTemplateBody, template.template]);
};
